<!-- 时间组件 -->
<template>
  <div class="block">
    <div class="pay-methods">
      <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>请选择收款方式</i></p>
      <div class="plr24 flex-row wraps">
        <div v-for="(item, index) in payWayList" :key="index" @click="payWayFun(item)" class="flex-row orderPayRadio" :class="[radio == item.payCode ? 'active':'']">
          <div class="pay-img"><img :src="item.imgUrl" alt /></div>
          <div class="fontSize16">{{item.payName}}</div>
          <div class="payCheak" v-if="radio == item.payCode"><img src="../../../assets/images/new/payRadio.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    member: {
      type: Boolean,
      default: null
    },
    data: {
      type: String,
      default: null
    },
    reset: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      radio: "cash",
      payWayList: []
    };
  },
  components: {},
  created() {
    this.getMenber();
  },

  methods: {
    payWayFun(item, index) {
      console.log(item);
      this.radio = item.payCode;
      this.$emit("payMentFun", item);
    },
    getMenber() {
      if (this.data === "widthdraw") {
        this.$api
          .get(this.$url.paywaySet.oldList, {
            isMember: this.member
            // sourceFrom: this.data
          })
          .then(res => {
            if (res) {
              this.payWayList = res;
              for (let i in this.payWayList) {
                if (i == 0) {
                  this.radio = this.payWayList[i].payCode;
                  this.$emit("payMentFun", this.payWayList[i]);
                }
              }
            }
          });
      } else {
        this.$api
          .get(this.$url.paywaySet.list, {
            isMember: this.member,
            sourceFrom: this.data
          })
          .then(res => {
            if (res) {
              this.payWayList = res;
              for (let i in this.payWayList) {
                if (i == 0) {
                  this.radio = this.payWayList[i].payCode;
                  this.$emit("payMentFun", this.payWayList[i]);
                }
              }
            }
          });
      }
    }
  },
  watch: {
    reset (o) {
      console.log(o);
      if (o) {
        for (let i in this.payWayList) {
          if (i == 0) {
            this.radio = this.payWayList[i].payCode;
            this.$emit("payMentFun", this.payWayList[i]);
          }
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ div .el-radio__label {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: 60%;
  .label-boxs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
  }
}
.pay-methods {
    .orderPayRadio {
      box-sizing: border-box;
      width: 32%;
      height: 56px;
      background: #FFFFFF;
      border: 1px solid #DCDEE0;
      border-radius: 4px;
      align-items: center;
      padding-left: 16px;
      cursor: pointer;
      position: relative;
      margin-right: 2%;
      margin-bottom: 10px;
      &:nth-of-type(3n) {
        margin-right: 0 !important;
      }
      .payCheak {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0;
        right: 0;
      }
      .pay-img {
        width: 30px;
        height: 30px;
        margin-right: 10px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .active {
      color: #3388FF;
      border: 1px solid #3388FF;
      background: #EAF4FE;
    }
  }
</style>
